import * as React from "react"
import {map as _map} from "lodash";
import * as $ from "jquery"
import {IPatientVitalHistory, IPatientVitalResponse} from "../../../models/IPatientVitalResponse"
import AppUtils from "../../../utils/AppUtils"
import {Chart} from "react-google-charts"
import { ORION_IMG_URL } from "../../../utils/AppConstants";

/**
 * Created by abhinav on 28/01/18.
 */

export interface PatientVitalsViewProps {
    patientVitals: IPatientVitalResponse[];
}


export interface PatientVitalsViewState {

}

export const VitalsChartOptions = {
    // curveType: "function",
    pointsVisible: true,
    legend: {position: "none"},
    backgroundColor: "#f1f5f8",
    hAxis: {baselineColor: "transparent", gridlines: {color: "transparent"}, textStyle: {color: "transparent"}},
    vAxis: {baselineColor: "transparent", gridlines: {color: "transparent"}, textStyle: {color: "transparent"}}
}

export const vitalsToChart = ["BP", "TEMPERATURE"]

class PatientVitalsView extends React.Component<PatientVitalsViewProps, PatientVitalsViewState> {

    constructor(props: PatientVitalsViewProps) {
        super(props);
    }

    showChart(event: any) {
        $(event.target).closest(".vital-chart-body").toggleClass("expanded");
    }

    generateDataTable = (vitalsData: IPatientVitalHistory[], vitalName: string) => {
        // let vitalsData = this.props.patientVitals[4].vitalHistoryList;
        let chartData = [["Index", vitalName]];
        _map(vitalsData, (vital, index) => {
            let item = [];
            item.push(index);
            item.push(parseFloat(vital.value));
            chartData.push(item as any);
        })
        return chartData;
    }

    render() {
        let myInstance = this;
        let vitals = this.props.patientVitals;
        return (
            <div className="patient-vitals-cont">
                {
                    vitals.length ?
                    _map(this.props.patientVitals, function(patientVital: IPatientVitalResponse, index){
                    let patientCurrVitalText = AppUtils.sortPatientVitalHistory(patientVital.vitalHistoryList)[0].value + " " + patientVital.unit;
                    // patientVital.avgValue
                    let patientAvgVitalText = "6 " + patientVital.unit;

                    return (
                        <div className="patient-vitals in-blk top-align" key={index}>
                            <div className="vital-name">{patientVital.vitalName}</div>
                            <div className="vital-info-card">
                                <div className="vital-info-header">
                                    <span className="vital-current-label pull-left">Current</span>
                                    <span className="vital-average-laber pull-right">Average</span>
                                </div>

                                <div className="vital-info-body">
                                    <span className="vital-current pull-left"> {patientCurrVitalText} </span>
                                    <span className="vital-average pull-right"> {patientAvgVitalText} </span>
                                </div>

                                {
                                    vitalsToChart.indexOf(patientVital.vitalName) > -1 &&
                                    <div className="vital-chart-body">
                                        <div id={"chart-container"}>
                                            <Chart
                                                chartType="LineChart"
                                                data={myInstance.generateDataTable(patientVital.vitalHistoryList, patientVital.vitalName)}
                                                options={VitalsChartOptions}
                                                graph_id={`LineChart-${index}`}
                                                width="100%"
                                                height="200px"
                                                legend_toggle
                                            />
                                        </div>
                                        <div className={"show-chart-label-container"}>
                                            <img className="date-navigator date-right-nav" src={ORION_IMG_URL + "date-right-nav.png"} title={"Show Chart"} onClick={(event) => {myInstance.showChart(event)}}/>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>)
                    }) : <div className={"no-record-found-label"}>Vitals not recorded</div>
                }
            </div>
        );
    }
}

export default PatientVitalsView